// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__sDshV","ellipsis":"styles_ellipsis__pG_AP","text2AndMoreLines":"styles_text2AndMoreLines__ubk4G","tooltipTrigger":"styles_tooltipTrigger__2ns3h"};